/**
 * 扁平化树形结构数据
 * @param data 树形结构数组
 * @param childrenKey 子节点属性名，默认为 'children'
 * @returns 扁平化后的数组
 */
export const flattenTree = <T extends Record<string, any>>(
  data: T[],
  childrenKey: string = 'children',
): T[] => {
  let result: T[] = [];
  data.forEach((item) => {
    const { [childrenKey]: children, ...rest } = item;
    result.push(item);
    if (children && Array.isArray(children) && children.length > 0) {
      result = result.concat(flattenTree(children, childrenKey));
    }
  });
  return result;
};
